var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-cell"},[_c('BorrowReturnStatusCard',{staticClass:"w-100 text-center p-0",attrs:{"status":_vm.params.value.name}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }